import React, { PureComponent } from 'react'
import { Button, OverlayTrigger, Tooltip, Form } from 'react-bootstrap'
import { Field, reduxForm, reset } from 'redux-form'
import InputSelect from '../commons/form/InputSelect'
import InputDatePicker from '../commons/form/InputDatePicker'
import SimpleTablePage from '../../containers/commons/general/SimpleTablePage'
import IDocCarPagination from '../../components/commons/iDocCarPagination'
import MapSectionsReport from '../../util/map-sections-report'
import { showFilter, hideFiltersBtn, toggleFilterClass } from '../../util/management/ManagementUtils'
import { handleKeyDown, formatDate } from '../../util/utils'
import UsageReportModal from './Modals/UsageReportModal'

class SearchUsageReport extends PureComponent {
  constructor () {
    super()
    this.state = {
      showModal: false,
      searched: false,
      hasFilters: false,
      filter: {
        searchOrganizedUnit: [],
        searchProcess: [],
        searchDateInitial: null,
        searchDateEnd: null,
        searchUser: null
      }
    }
  }

  searchUsage () {
    if (!this.state.filter.searchOrganizedUnit || this.state.filter.searchOrganizedUnit.length === 0) {
      this.props.actions.openModal('ORGANIZED_UNIT_MANDATORY')
      return
    }
    if (this.state.filter.searchDateInitial && this.state.filter.searchDateEnd &&
      new Date(this.state.filter.searchDateInitial) > new Date(this.state.filter.searchDateEnd)) {
      this.props.actions.openModal('DATE_TO_BIGGER_THAN_DATE_FROM')
      return
    }
    this.setState({ searched: true })
    this.props.actions.fetchUsageList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  downloadUsageList () {
    const columns = [
      this.props.t('REPORTS.USAGE.PROCESS'),
      this.props.t('REPORTS.USAGE.AMOUNT')
    ]
    this.props.actions.downloadUsageList({ ...this.props.filter, ...this.state.filter, page: this.props.filter.page, columnNames: columns })
  }

  componentDidMount () {
    this.props.actions.fetchUserCombo()
    this.props.actions.fetchUsageProcessTypesCombo()
    this.props.actions.fetchOrganizedUnitsAcceptClientsCombo()

    if (this.props.dynamicFilters && this.props.dynamicFilters.processTypeId) {
      this.setState({ searched: true, hasFilters: true, showModal: true, filter: { ...this.props.dynamicFilters } })
      this.props.actions.fetchUsageList({ ...this.props.dynamicFilters })
      this.props.change('filters.OrganizedUnitId', this.props.dynamicFilters.searchOrganizedUnit)
      this.props.change('filters.processId', this.props.dynamicFilters.searchProcess)
      this.props.change('filters.dateFrom', this.props.dynamicFilters.searchDateInitial && formatDate(this.props.dynamicFilters.searchDateInitial.split('T')[0]))
      this.props.change('filters.dateTo', this.props.dynamicFilters.searchDateEnd && formatDate(this.props.dynamicFilters.searchDateEnd.split('T')[0]))
      this.props.change('filters.userId', this.props.dynamicFilters.searchUser)
    } else {
      this.props.actions.clearSearch()
    }
  }

  handleOrganizedUnitChange (searchOrganizedUnit) {
    this.clearSearchResultList()
    if (this.state.filter.searchOrganizedUnit !== searchOrganizedUnit) {
      this.setState({ filter: { ...this.state.filter, searchOrganizedUnit: searchOrganizedUnit }, searched: false }, () => this.checkFilters())
    }
  }

  handleProcessChange (searchProcess) {
    this.clearSearchResultList()
    if (this.state.filter.searchProcess !== searchProcess) {
      this.setState({ filter: { ...this.state.filter, searchProcess: searchProcess }, searched: false }, () => this.checkFilters())
    }
  }

  handleDateInitialChange (searchDateInitial) {
    this.clearSearchResultList()
    if (this.state.filter.searchDateInitial !== searchDateInitial && searchDateInitial != null) {
      const [dd, mm, yyyy] = searchDateInitial.split('/')
      this.setState({ filter: { ...this.state.filter, searchDateInitial: `${yyyy}-${mm}-${dd}T00:00:01.000Z` }, searched: false }, () => this.checkFilters())
    } else {
      this.setState({ filter: { ...this.state.filter, searchDateInitial: null }, searched: false }, () => this.checkFilters())
    }
  }

  handleDateEndChange (searchDateEnd) {
    this.clearSearchResultList()
    if (this.state.filter.searchDateEnd !== searchDateEnd && searchDateEnd != null) {
      const [dd, mm, yyyy] = searchDateEnd.split('/')
      this.setState({ filter: { ...this.state.filter, searchDateEnd: `${yyyy}-${mm}-${dd}T23:59:59.000Z` }, searched: false }, () => this.checkFilters())
    } else {
      this.setState({ filter: { ...this.state.filter, searchDateEnd: null }, searched: false }, () => this.checkFilters())
    }
  }

  handleUserChange (searchUser) {
    this.clearSearchResultList()
    if (this.state.filter.searchUser !== searchUser) {
      this.setState({ filter: { ...this.state.filter, searchUser: searchUser }, searched: false }, () => this.checkFilters())
    }
  }

  openHideModal (id) {
    this.setState({ showModal: !this.state.showModal })
    if (id) {
      this.props.actions.fetchUsageInfo({ ...this.props.filter, ...this.state.filter, processTypeId: id, page: 1 })
    } else {
      this.props.actions.clearDynamicFilters()
    }
  }

  getIconClass (field) {
    if (this.props.filter && this.props.filter.orderBy.includes(field)) {
      return this.props.filter.orderBy.includes('-') ? 'ico-sort-selected-asc' : 'ico-sort-selected-desc'
    } else {
      return 'ico-sort'
    }
  }

  onOrderChange (e) {
    if (this.props.filter) {
      const newOrderBy = this.props.filter.orderBy.includes(`+${e.currentTarget.dataset.field}`) ? `-${e.currentTarget.dataset.field}` : `+${e.currentTarget.dataset.field}`
      this.props.actions.fetchUsageList({ ...this.props.filter, ...this.state.filter, orderBy: newOrderBy })
    }
  }

  resetFilters () {
    this.clearSearchResultList()
    this.props.initialize({ filters: {} })
    this.setState({
      searched: false,
      hasFilters: false,
      filter: {
        searchOrganizedUnit: [],
        searchProcess: [],
        searchDateInitial: null,
        searchDateEnd: null,
        searchUser: null
      }
    })
  }

  checkFilters () {
    const newCheckFilters = this.state.filter.searchOrganizedUnit?.length > 0 || this.state.filter.searchProcess?.length > 0 ||
      this.state.filter.searchDateInitial || this.state.filter.searchDateEnd || this.state.filter.searchUser
    this.setState({ hasFilters: newCheckFilters })
  }

  clearSearchResultList () {
    if (this.props.hasSearch) {
      this.props.actions.clearSearchResultList()
    }
  }

  handleClickReset (e) {
    if (e !== undefined) {
      e.preventDefault()
    }

    this.props.dispatch(reset('usageReport'))
  }

  submitSearchForm (values) {
    this.searchUsage()

    this.setState({ hideFilters: true, dossierIdToArray: [], dynamicFilters: values, filterValues: { ...values.fleetReport, ...this.props.filters } })

    this.props.actions.setFilters(values)
  }

  onPageChange (page) {
    this.props.actions.fetchUsageList({ ...this.state.filterValues, page })
  }

  toogleHideFilters () {
    this.setState({ hideFilters: !this.state.hideFilters })
  }

  toogleMaxiTable () {
    this.setState({ maxiTable: !this.state.maxiTable })
  }

  render () {
    const {
      t, combos: { usersCombo, UOAcceptClientsCombo, usageProcessTypesCombo }, hasSearch, usageList, usageModal,
      actions: { fetchUsageInfo, downloadUsageInfo },
      page, pages, count,
      handleSubmit // From search
    } = this.props
    const tKey = 'REPORTS.'
    const setOpenTooltip = (<Tooltip id="setActiveTooltip">{t(`${tKey}USAGE.ACTION_OPEN_TOOLTIP`)}</Tooltip>)
    const dKey = 'GLOBAL.TABLES.'
    const secMapReport = MapSectionsReport.find(function (s) { return s.page === 'usageReportPage' })
    const hasResults = usageList && usageList.length > 0

    return (
      <div id='searchUsageReport' className="inner-results-panel">
        <UsageReportModal
          t={t}
          showModal={this.state.showModal}
          actions={{
            fetchUsageInfo,
            downloadUsageInfo,
            handleHide: () => this.openHideModal(null)
          }}
          filter={this.state.filter}
          modalInfo={usageModal}
        />
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4 className={'hasFilters' + hideFiltersBtn(hasResults)} onClick={() => this.toogleHideFilters()}>{t(`${secMapReport.title}`)}
              <OverlayTrigger placement="left" overlay={<Tooltip id="editProductTooltip">{`${t((this.state.hideFilters ? 'GLOBAL.TABLES.SHOW_FILTERS' : 'GLOBAL.TABLES.HIDE_FILTERS'))}`}</Tooltip>}>
                <a onClick={() => this.toogleHideFilters()} className={'toogleShowFilters ' + hideFiltersBtn(hasResults)}><i className={toggleFilterClass(hasResults, this.state.hideFilters)}></i></a>
              </OverlayTrigger>
            </h4>
          </div>

          <Form autoComplete="off" onSubmit={handleSubmit((values) => this.submitSearchForm(values))} onKeyDown={(e) => handleKeyDown(e)} className="filters">
            <div className={'search-form ' + (showFilter(hasResults, this.state.hideFilters) ? '' : 'hideFilters ')}>
              <Field
                component={InputSelect}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                id="OrganizedUnitId"
                name="usageReport.OrganizedUnitId"
                placeholder={t(`${tKey}USAGE.ORGANIZED_UNIT`)}
                controlLabel={t(`${tKey}USAGE.ORGANIZED_UNIT`)}
                options={UOAcceptClientsCombo}
                multi={true}
                valueKey="id"
                labelKey="value"
                onInputChange={(value) => this.handleOrganizedUnitChange(value)}
              />
              <Field
                component={InputSelect}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                id="processId"
                name="filters.processId"
                placeholder={t(`${tKey}USAGE.PROCESS`)}
                controlLabel={t(`${tKey}USAGE.PROCESS`)}
                options={usageProcessTypesCombo}
                multi={true}
                valueKey="id"
                labelKey="name"
                onInputChange={(value) => this.handleProcessChange(value)}
              />
              <Field
                component={InputDatePicker}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                id="dateFrom"
                name="filters.dateFrom"
                controlLabel={t(`${tKey}USAGE.DATE_FROM`)}
                placeholder={t(`${tKey}USAGE.DATE_FROM`)}
                onInputChange={(value) => this.handleDateInitialChange(value)}
              />
              <Field
                component={InputDatePicker}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                id="dateTo"
                name="filters.dateTo"
                placeholder={t(`${tKey}USAGE.DATE_TO`)}
                controlLabel={t(`${tKey}USAGE.DATE_TO`)}
                onInputChange={(value) => this.handleDateEndChange(value)}
              />
              <Field
                component={InputSelect}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                name="filters.userId"
                placeholder={t(`${tKey}USAGE.USER`)}
                controlLabel={t(`${tKey}USAGE.USER`)}
                multi={false}
                valueKey="id"
                labelKey="value"
                childrenKey="children"
                options={usersCombo}
                onInputChange={(value) => this.handleUserChange(value)}
              />

              <div className='search-form-actions flexInLine al-R'>
                <Button id="btn_search"
                  type="submit"
                  className="_Btn accept stk">
                  <i className="iDocIcon-search"/>
                  {t('SEARCH.ACTIONS.SEARCH_BUTTON')}
                </Button>
                <Button
                  id="btn_reset"
                  onClick={(e) => this.handleClickReset(e)}
                  className={'_Btn' + (this.props.pristine ? ' accept' : ' accept')}
                  disabled={this.props.pristine}>
                  <i className="iDocIcon-clear-decline"/>
                  {t('SEARCH.ACTIONS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </Form>
        </div>
        <div className="section-results-body">
          <div className={'searchResoultsContainer' + (this.state.maxiTable ? ' maxiTable' : '')}>
            {hasSearch && ([
              <div className="table-wrapper fleets" key="table-wrapper">
                {/* table options, maximize, etc.... */}
                {hasResults &&
                  <div className='flexInLine al-R'>
                    <OverlayTrigger placement="left" overlay={<Tooltip id="editProductTooltip">{`${t(dKey + (this.state.maxiTable ? 'MINIMIZE_TABLE' : 'MAXIMIZE_TABLE'))}`}</Tooltip>}>
                      <a onClick={() => this.toogleMaxiTable()} className='_Btn accept stk o-icn maximizeBtn'><i className={(this.state.maxiTable ? 'iDocIcon-Minimize' : 'iDocIcon-Maximize')}></i></a>
                    </OverlayTrigger>
                  </div>
                }
                {/* table */}
                { hasResults &&
                <div className="table-responsive">
                  <SimpleTablePage
                    columns={[
                      <th key={0} data-field="process" onClick={(event) => this.onOrderChange(event)}>
                        {t(`${tKey}USAGE.PROCESS`)}&nbsp;<i className={this.getIconClass('process')}/>
                      </th>,
                      <th className='navigation' key={1} data-field="amount" onClick={(event) => this.onOrderChange(event)}>
                        {t(`${tKey}USAGE.AMOUNT`)}&nbsp;<i className={this.getIconClass('amount')}/>
                      </th>,
                      <th className='navigation' key={2}>
                        {t(`${tKey}USAGE.ACTIONS`)}&nbsp;
                      </th>
                    ]}
                    rows={usageList && usageList.map((usage, idx) => (
                      <tr key={idx}>
                        <td>{usage.process}</td>
                        <td className='navigation'>{usage.amount}</td>
                        <td className='navigation'>
                          <OverlayTrigger placement="left" overlay={setOpenTooltip}>
                            <a className='_Btn accept stk o-icn' onClick={() => this.openHideModal(usage.processId)}>
                              <i className="iDocIcon-search"/>
                            </a>
                          </OverlayTrigger>
                        </td>
                      </tr>
                    ))}
                  />
                </div>}
                { !hasResults &&
                <p className='no_results'>{t(`${tKey}USAGE.MODAL.RESULTS_NOT_FOUND`)}</p>
                }
                <div className="search-footer" key="search-footer">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pages}
                    totalRows= {count}
                    onSelectAction={(page) => this.onPageChange(page)}
                  />
                </div>
              </div>
            ])}
          </div>
        </div>
      </div>
    )
  }
}

export default reduxForm({
  form: 'usageReport'
})(SearchUsageReport)
